export interface StateParam {
    return_url?: string;
    redirect_uri?: string;
    msp?: boolean;
    msp_id?: string;
    stay_signed_in?: boolean;
    /** First-touch UTMs from the `octiga_utm` cookie, sent only by the sign-in page (see `utm-attribution.ts`). */
    utm_campaign?: string;
    utm_content?: string;
}

export function EncodeStateParam(state: StateParam): string {
    return encodeURIComponent(JSON.stringify(state));
}
